import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/admin/contact/details/')({
  component: () => <Navigate to="/dashboard/admin/contact/list" />,
});
